<template>
    <div style="display:inline-block;">
        <span style="font-weight: bold;color:#000;font-size:12px">
            【天宝软件 0755-88830881】
        </span>
    </div>
</template>

<script>
export default {
    data: function() {
        return {};
    },
    created() {},
    methods: {}
};
</script>

<style scoped></style>
